import FeatureItem from "./FeatureItem";

const FeaturesSection = () => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12 w-full max-w-6xl mx-auto py-10">
      
      <FeatureItem
        number="01"
        text="Skill development through continuous challenges and learning content."
      />

      <FeatureItem
        number="02"
        text="Community exposure and recognition through curated galleries."
      />

      <FeatureItem
        number="03"
        text="Professional growth with personalized feedback and micro-grant opportunities."
      />

      <FeatureItem
        number="04"
        text="Encouragement and motivation through a vibrant creative community."
      />

    </div>
  );
};

export default FeaturesSection;
